"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImplicitHydrogensCount = void 0;
function getImplicitHydrogensCount(molecule, atomID) {
    molecule.ensureHelperArrays(molecule.getOCL().Molecule.cHelperNeighbours);
    return (molecule.getAllHydrogens(atomID) +
        molecule.getConnAtoms(atomID) -
        molecule.getAllConnAtoms(atomID));
}
exports.getImplicitHydrogensCount = getImplicitHydrogensCount;
//# sourceMappingURL=getImplicitHydrogensCount.js.map